import request from '@/axios'

// 删除文件
export const delFile = (params: any) => {
  return request.delete({ url: '/common', params })
}

// 批量删除文件
export const bachDelFile = (data: any) => {
  return request.post({ url: '/common/bachDelFile', data })
}

// 上传文件
export const uploadFile = (data: any) => {
  return request.post({
    url: '/common/upload',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// minio上传文件
export const uploadMinioFile = (data: any) => {
  return request.post({
    url: '/minio/upload',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// minio批量上传文件
export const batchUploadMinioFile = (data: any) => {
  return request.post({
    url: '/minio/batchUpload',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// minio删除文件
export const deleteMinioFile = (key: any) => {
  return request.delete({
    url: '/minio/delete',
    params: { key }
  })
}

// minio批量删除文件
export const batchDeleteMinioFile = (data: string[]) => {
  return request.delete({
    url: '/minio/batchDelete',
    data
  })
}

// minio下载文件
export const downloadMinioFile = (key: any) => {
  return request.get({
    url: '/minio/download',
    params: { key },
    responseType: 'blob'
  })
}

// minio批量下载文件
export const batchDownloadMinioFile = (data: string[]) => {
  return request.post({
    url: '/minio/batchDownload',
    data,
    responseType: 'blob'
  })
}

// minio获取临时访问URL
export const getMinioTempUrl = (key: string) => {
  return request.get({
    url: '/minio/presignedUrl',
    params: { key }
  })
}
